var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablet2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "204.295px",
    height: "178.95px",
    viewBox: "0 0 204.295 178.95",
    enableBackground: "new 0 0 204.295 178.95",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9C6C3",
    points: "62.406,59.496 2,51.482 3.019,57.672 131.989,175.574 138.542,174.496 140.895,152.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E8E5DC",
    points: "2,51.482 138.542,174.496 199.377,94.183 98.199,2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#54B3E5",
    points: "97.396,8.489 191.513,94.115 136.723,162.404 13.944,53.067  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet2);
export default __webpack_public_path__ + "static/media/tablet2.dc9bc82539c543386a7900dcd6a2c02d.svg";
export { ForwardRef as ReactComponent };